
<!-- 考试数据中心 -->

<template>
  <div class="hbn-container" id="ExamReportList">
    <div class="search-form">
      <el-row :gutter="24">
        <el-col :span="18">
          <el-form
            ref="form"
            :model="form"
            label-width="80px"
            label-position="right"
            size="mini"
          >
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="试卷名称">
                  <el-input
                    id="examName"
                    v-model="PageQuery.queryModel.examName"
                    placeholder="试卷名称"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="试卷分类">
                  <el-input
                    id="categoryName"
                    v-model="PageQuery.queryModel.categoryName"
                    placeholder="试卷分类"
                    clearable
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
        <el-col :span="6">
          <el-form-item>
            <el-button size="mini" class="hbn-button-serach" @click="seach"
              >查找</el-button
            >
            <span class="control-collapse" @click="show = !show">{{
              show ? "收起" : "展开"
            }}</span>
          </el-form-item>
        </el-col>
      </el-row>
    </div>

    <div class="hbn-table-screen">
      <div class="custom-table-layer">
        <div style="margin-bottom: 13px">
          <vxe-table
            :data="DataList"
            round
            border
            height="388"
            class="mytable-scrollbar"
            style="width: 100%"
            :highlight-current-row="true"
            @current-change="handleCurrentChange"
            @checkbox-change="handleSelectionChange"
            ref="multipleTable"
            highlight-hover-row
            highlight-hover-column
            highlight-current-column
            show-overflow="tooltip"
            empty-text="没有更多数据了！"
            resizable
            stripe
          >
            <vxe-table-column
              fixed="left"
              type="checkbox"
              width="40"
            ></vxe-table-column>
            <vxe-table-column
              fixed="left"
              type="seq"
              width="55"
              title="序号"
              align="center"
            ></vxe-table-column>

            <template v-for="(item, key) in ExamReportList" :key="key">
              <vxe-table-column
                v-if="item.isShow"
                :field="item.prop"
                :title="item.label"
                :width="item.width"
                align="center"
                show-overflow-tooltip
                :class-name="JSON.stringify(item)"
                :formatter="formatterData"
              />
            </template>

            <vxe-table-column
              width="200"
              fixed="right"
              title="操作"
              align="center"
            >
              <template #default="{ row }">
                <el-button
                  type="text"
                  size="small"
                  @click="handleClick(row, 'Detail')"
                  >查看</el-button
                >
              </template>
            </vxe-table-column>
          </vxe-table>
        </div>

        <div class="pagination">
          <vxe-pager
            perfect
            size="mini"
            :current-page="PageQuery.pageindex"
            :page-size="PageQuery.PageSize"
            :page-sizes="[20, 50, 100, 500]"
            :total="total"
            :pager-count="5"
            :layouts="[
              'PrevJump',
              'PrevPage',
              'JumpNumber',
              'NextPage',
              'NextJump',
              'FullJump',
              'Sizes',
              'Total',
            ]"
            @page-change="handlePageChange"
          >
          </vxe-pager>
        </div>
      </div>
    </div>
  </div>
  <ExamReportDetail
    ref="ExamReportDetail"
    v-model:dialogVisible="dialogVisible"
    @close-dialog="closeDialog"
    @handle-cancel="handleCancel"
    @handle-confirm="handleConfirm"
  ></ExamReportDetail>
</template>

<script>
import { Search, Delete } from "@element-plus/icons";
import { ExamReportList } from "@/assets/apiData/Exam/ExamReportList";
import { GetExamResultDataByPageQuery } from "@api/Exam/ApiExamDataCenter";
import ExamReportDetail from "./ExamReportDetail.vue";
import excel from "@comp/ExcelHelper/importExcel";
import Enumerable from "linq";
import XEUtils from "xe-utils";

export default {
  data() {
    return {
      PageQuery: {
        queryModel: {
          examName: "",
          categoryName:"",
        },
        pageindex: 1,
        PageSize: 20,
      },
      total: 0,
      multipleSelection: [],
      dialogVisible: false,
      UpLoaddialogVisible: false,
      seldata: {
        dialogGUID: "",
        dialogtype: "",
      },
      show: false,

      ExamReportList: [],
      DataList: [],
    };
  },
  components: {
    ExamReportDetail,
    excel,
    Search,
  },
  computed: {
    checkendSum() {
      return this.multipleSelection.length;
    },
  },
  methods: {
    formatterData: function ({ cellValue, row, column }) {
      let head = JSON.parse(column.className);
      let format = head.format;
      switch (format) {
        case "datetime":
          cellValue = XEUtils.toDateString(cellValue, "yyyy-MM-dd HH:ss:mm");
          break;
      }
      return cellValue;
    },
    error() {},
    success() {},
    closeUpDialog() {
      this.UpLoaddialogVisible = false;
    },
    handleClick(row, type) {

      this.dialogVisible = true;

      this.$refs.ExamReportDetail.loadDataById(row);
    },
    //选中事件
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    seach() {
      this.PageQuery.pageindex = 1;
      this.GetData();
    },

    handleSizeChange(val) {
      //分页
    },
    handlePageChange({ currentPage, pageSize }) {
      if (this.PageQuery.PageSize != pageSize) {
        this.PageQuery.pageindex = 1; //说明更改了每页展示条数，要从第一页进行展示
        this.PageQuery.PageSize = pageSize;
      } else {
        this.PageQuery.pageindex = currentPage;
      }
      this.GetData();
    },
    handleCurrentChange(val) {
      console.log(val);
      // this.GetData();
    },
    SearchDataInfo() {},
    GetData() {
      const _this = this;
      this.SearchDataInfo();
      const loading = this.loading()
      try {
        GetExamResultDataByPageQuery(this.PageQuery).then(data =>{
            loading.close();
            _this.DataList = data.entities;
            _this.total = data.totalCount;
        });
      } catch (e) {
        loading.close();
        console.log(e);
      }
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    handleCancel() {
      this.dialogVisible = false;
    },
    handleConfirm(val) {
      this.dialogVisible = false;
      this.PageQuery.pageindex = 1;
      this.GetData();
    },
  },
  created() {
    this.ExamReportList = ExamReportList;
    this.GetData();
  },
};
</script>
<style lang="scss" scoped>
@import "@/common/css/Hbn_modules/reset-input";
.custom-table-header > th {
  background: #dfdfdf !important;
}

.custom-table-header > th > .cell {
  font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
  font-weight: 500;
  color: #868686 !important;
  line-height: 22px;
}

.custom-table-layer ::v-deep .el-table .cell {
  color: #32383d;
}
.el-table .cell {
  color: #32383d;
}

.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {
  display: none;
}
.custom-table-layer .el-pagination.is-background .btn-prev,
.custom-table-layer .el-pagination.is-background .btn-next,
.custom-table-layer .el-pagination.is-background .el-pager li {
  border: 1px solid #acb5bd;
  width: 32px;
  height: 32px;
  line-height: 32px;
  background-color: #fff;
}
</style>
<style lang="scss" scoped>
@import "@/common/css/Hbn_modules/hbn-base-model";
#userInfo {
}
</style>
<style scoped>
</style>
